export default __webpack_public_path__ + "static/media/mariog15.c05cfb25.jpg";